import { ApiErrorResponse } from '../models';

const MAX_RETRIES = 3;

export function shouldRetry(failureCount, error: any): boolean {
  if (failureCount > MAX_RETRIES) {
    return false;
  }

  const status = (error as ApiErrorResponse).status;

  if (status >= 500) {
    return true;
  }

  if (status === 429 || status === 408) {
    return true;
  }

  return false;
}
